import { ApiClient } from '../utils/api-client'
import { ExerciseHistoryResponse, HandGripHistoryResponse, FatigueHistoryResponse } from '../types'

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_EXERCISEBOT_BASE_URL || 'https://tatva-exercise-bot-uat.mytatva.in',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
}

const apiClient = new ApiClient(API_CONFIG)

export const exerciseService = {
  async getExerciseHistory(userId: string, page: number = 1, limit: number = 10): Promise<ExerciseHistoryResponse> {
    try {
      const response = await apiClient.get<ExerciseHistoryResponse>(
        '/exercise/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('Exercise History API Error:', error)
      throw new Error(error.message || 'Failed to fetch exercise history')
    }
  },

  async getGripHistory(userId: string, page: number = 1, limit: number = 10): Promise<HandGripHistoryResponse> {
    try {
      const response = await apiClient.get<HandGripHistoryResponse>(
        '/handgrip/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('Grip History API Error:', error)
      throw new Error(error.message || 'Failed to fetch grip history')
    }
  },

  async getFatigueHistory(userId: string, page: number = 1, limit: number = 10): Promise<FatigueHistoryResponse> {
    try {
      const response = await apiClient.get<FatigueHistoryResponse>(
        '/fatigue/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('Fatigue History API Error:', error)
      throw new Error(error.message || 'Failed to fetch fatigue history')
    }
  },

  async deleteExerciseLog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/exercise/history',
        {
          params: {
            user_id: userId,
            log_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete Exercise Log API Error:', error)
      throw new Error(error.message || 'Failed to delete exercise log')
    }
  },

  async deleteGripLog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/grip/history',
        {
          params: {
            user_id: userId,
            log_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete Grip Log API Error:', error)
      throw new Error(error.message || 'Failed to delete grip log')
    }
  },

  async deleteFatigueLog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/fatigue/history',
        {
          params: {
            user_id: userId,
            log_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete Fatigue Log API Error:', error)
      throw new Error(error.message || 'Failed to delete fatigue log')
    }
  }
} 